package feature.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Language(
    @SerialName("code") var code: String = "",
    @SerialName("Name") var name: String? = null,
)